// BSV CHANGES
import React, {useEffect, useState} from 'react';
import {
  Button,
  Typography,
  Box,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  OutlinedInput,
  Checkbox,
  ListItemText,
  TextField,
  FormHelperText,
  Autocomplete,
  Dialog,
  CircularProgress,
} from '@mui/material';
import {LocalizationProvider, DatePicker} from '@mui/x-date-pickers';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import {isBefore} from 'date-fns';
import {useSelector, useDispatch} from 'react-redux';
import {routeStateActions} from '@app/router/redux';
import {navbarComponentName} from '@app/router/redux/routeHandler';
import {useStyles} from './styles';
import {strings} from '@app/common/strings';
import {billLibraryStateSelector} from '../bill-library/redux/selectors';
import {fetchDivisionCreator} from '../bill-library/redux/slice';
import {getExpenseReportsData, getExpenseReportsLoading, HQPositionRequest, postDownloadRequest} from './redux';
import {fetchHqForGenerateReportCreator} from '../generateReport/redux/slice';
import {generateReportStateSelector} from '../generateReport/redux/selectors';
import {fetchStaffDataCreator} from '../approve-expenses/redux/slice';
import {SEARCH_OBJECT} from '../../module-specific-utilities.types';
import {approveExpenseStateSelector} from '../approve-expenses/redux/selectors';

export const util: any = {downloadExcel: null};

const REPORT_TYPES = [
  {label: 'MSL', value: 1},
  {label: 'Organogram', value: 2},
  {label: 'DCR Submission', value: 3},
  {label: 'Last DCR Submitted', value: 4},
  {label: 'DCR Consolidated Report', value: 5},
  {label: 'Attendance Report', value: 6},
  {label: 'Expense Claim Approval Report', value: 7},
  {label: 'SFC Master', value: 8},
  {label: 'DMS', value: 9},
  {label: 'EDetailing Dump', value: 10},
];

const BSVstartYear = 2025;

// Month options
const MONTHS = [
  {label: 'January', value: 1},
  {label: 'February', value: 2},
  {label: 'March', value: 3},
  {label: 'April', value: 4},
  {label: 'May', value: 5},
  {label: 'June', value: 6},
  {label: 'July', value: 7},
  {label: 'August', value: 8},
  {label: 'September', value: 9},
  {label: 'October', value: 10},
  {label: 'November', value: 11},
  {label: 'December', value: 12},
];

type DivisionOption = {
  value: number;
  label: string;
};


export const Reports = () => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const [selectedReportType, setSelectedReportType] = useState<number | ''>('');
  const [selectedDivisions, setSelectedDivisions] = useState<number[]>([]);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [startDateError, setStartDateError] = useState<string | null>(null);
  const [endDateError, setEndDateError] = useState<string | null>(null);
  const [selectedMonths, setSelectedMonths] = useState<number[]>([]);
  const [selectedYears, setSelectedYears] = useState<number[]>([]);
  const [tempSelection, setTempSelection] = useState<number[]>([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [tempMonths, setTempMonths] = useState<number[]>([]);
  const [monthMenuOpen, setMonthMenuOpen] = useState(false);
  const [tempYears, setTempYears] = useState<number[]>([]);
  const [yearMenuOpen, setYearMenuOpen] = useState(false);
  const [selectedHQ, setSelectedHQ] = useState<string[]>([]);
  const [searchHQ, setSearchHQ] = useState('');
  const [openHQ, setOpenHQ] = useState(false);
  const [tempHQ, setTempHQ] = useState<string[]>([]);
  const [employeeSearch, setEmployeeSearch] = useState('');
  const [employeeOptions, setEmployeeOptions] = useState<any[]>([]);
  const [selectedEmployee, setSelectedEmployee] = useState<number | null>(null);

  const divisionOptions: DivisionOption[] = useSelector(
    billLibraryStateSelector.getDivision(),
  );
  // const hqDropDown = useSelector(
  //   getExpenseReportsData
  // );
  const hqDropDown: string[] = useSelector(getExpenseReportsData) || [];
  useEffect(() => {
    dispatch(fetchDivisionCreator());
    dispatch(fetchHqForGenerateReportCreator());
    dispatch(
      routeStateActions.setNavbarComponentName(
        navbarComponentName.commonheader,
      ),
    );
    dispatch(
      routeStateActions.setNavbarComponentHeading(
        <div className={classes.navbarComponentHeadingEmpty}>
          {strings.ModuleSpecificUtilitie.downloadTypePage.DownloadReports}
        </div>,
      ),
    );
    return () => {
      dispatch(routeStateActions.setNavbarComponentName(null));
    };
  }, []);

  useEffect(() => {
    if (employeeSearch.length >= 3) {
      dispatch(
        fetchStaffDataCreator({
          searchData: employeeSearch,
          divisionIds: selectedDivisions,
          // InActive: !isActive,
        }),
      );
    }
  }, [employeeSearch]);

  useEffect(() => {
    if(selectedReportType == 9 || selectedReportType == 10){
      selectedDivisions.length > 0 ? dispatch(HQPositionRequest(selectedDivisions)): null
    }
  }, [selectedDivisions])
  
  const staffData: SEARCH_OBJECT[] = useSelector(
    approveExpenseStateSelector?.getStaffData(),
  );

  useEffect(() => {
    if (staffData) {
      setEmployeeOptions(staffData);
    }
  }, [staffData]);
  const isLoading = useSelector(getExpenseReportsLoading);
  const currentYear = new Date().getFullYear();
  const YEARS = Array.from({length: currentYear - 1999}, (_, i) => 2000 + i);

  const handleMonthOpen = () => {
    setTempMonths(selectedMonths);
    setMonthMenuOpen(true);
  };
  const handleMonthCancel = () => {
    setTempMonths([]);
    setMonthMenuOpen(false);
  };
  const handleMonthDone = () => {
    setSelectedMonths([...tempMonths]);
    setMonthMenuOpen(false);
  };
  const handleMonthSelectAll = () => {
    setTempMonths(MONTHS.map(m => m.value));
  };
  const handleMonthDeselectAll = () => {
    setTempMonths([]);
  };

  const handleYearOpen = () => {
    setTempYears(selectedYears);
    setYearMenuOpen(true);
  };

  const handleYearCancel = () => {
    setTempYears([]);
    setYearMenuOpen(false);
  };

  const handleYearDone = () => {
    setSelectedYears([...tempYears]);
    setYearMenuOpen(false);
  };

  const handleYearSelectAll = () => {
    setTempYears(YEARS);
  };

  const handleYearDeselectAll = () => {
    setTempYears([]);
  };

  const handleOpen = () => {
    setTempSelection(selectedDivisions);
    setMenuOpen(true);
  };

  const handleCancel = () => {
    setTempSelection([]);
    setMenuOpen(false);
  };

  const handleDone = () => {
    setSelectedDivisions(tempSelection);
    setMenuOpen(false);
  };

  const handleSelectAll = () => {
    setTempSelection(divisionOptions.map(opt => opt.value));
  };

  const handleDeselectAll = () => {
    setTempSelection([]);
  };

  const handleDownload = async () => {
    if (!selectedReportType) return;

    if (selectedReportType === 3) {
      const startError = validateDate(startDate, 'start');
      const endError = validateDate(endDate, 'end');
      setStartDateError(startError);
      setEndDateError(endError);
      if (startError || endError) return;
    }

    const payload: any = {
      selectedReportType: selectedReportType,
    };
    if (selectedReportType !== 8) {
      payload.divisionIds = selectedDivisions;
    }

    if (selectedReportType === 3) {
      payload.fromDate = startDate ? new Date(startDate).toISOString() : null;
      payload.toDate = endDate ? new Date(endDate).toISOString() : null;
    }

    if (
      selectedReportType === 5
    ) {
      payload.UserId = selectedEmployee;
    }

    if (
      selectedReportType === 5 ||
      selectedReportType === 6 ||
      selectedReportType === 7 ||
      selectedReportType === 10
    ) {
      payload.months = selectedMonths;
      payload.years = selectedYears;
    }

    if (selectedReportType === 9 || selectedReportType === 10) {
      payload.hqNames = selectedHQ;
    }

    try {
      dispatch(postDownloadRequest(payload));
    } catch (err) {
      console.error('Error downloading report:', err);
    }
  };

  const validateDate = (
    date: Date | null,
    field: 'start' | 'end',
  ): string | null => {
    if (!date) return 'Date is required';
    if (isBefore(date, new Date('2000-01-01'))) return 'Invalid date';
    if (field === 'end' && startDate && date < startDate) {
      return 'End Date cannot be before Start Date';
    }
    return null;
  };

  const DownloadProgressDialog = ({open}: {open: boolean}) => (
    <Dialog open={open}>
      <Box p={4} display="flex" flexDirection="column" alignItems="center">
        <CircularProgress />
        <Typography mt={2}>Download in progress…</Typography>
      </Box>
    </Dialog>
  );

  return (
    <Box mt={4} sx={{paddingLeft: 10, paddingRight: 10}}>
      <Typography variant="h6" gutterBottom>
        {strings.ModuleSpecificUtilitie.reports.SelectReport}
      </Typography>
      <FormControl fullWidth margin="normal">
        <InputLabel>
          {strings.ModuleSpecificUtilitie.reports.ReportType}
        </InputLabel>
        <Select
          value={selectedReportType}
          onChange={e => {
            const value = e.target.value === '' ? '' : Number(e.target.value);
            setSelectedReportType(value);
            setSelectedDivisions([]);
            setTempSelection([]);
            setStartDate(null);
            setEndDate(null);
            setSelectedMonths([]);
            setTempMonths([]);
            setTempYears([]);
            setSelectedYears([]);
            setSelectedHQ([]);
            setTempHQ([]);
            setSearchHQ('');
            if (value === 8) {
              setSelectedDivisions([]); // auto-clear divisions
            }
          }}
          input={<OutlinedInput label="Report Type" />}>
          {REPORT_TYPES.map(type => (
            <MenuItem key={type.value} value={type.value}>
              {type.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {selectedReportType && selectedReportType !== 8 && (
        <>
          {/* Division Select */}
          <Box mt={3}>
            {/* <Typography variant="h6" gutterBottom>
              {strings.ModuleSpecificUtilitie.reports.SelectDivisions}
            </Typography> */}
            <FormControl fullWidth margin="normal">
              <InputLabel>
                {strings.ModuleSpecificUtilitie.reports.Divisions}
              </InputLabel>
              <Select
                multiple
                open={menuOpen}
                onOpen={handleOpen}
                onClose={handleCancel} // backpress → cancel
                value={tempSelection}
                onChange={e => setTempSelection(e.target.value as number[])}
                input={<OutlinedInput label="Divisions" />}
                renderValue={selected =>
                  (selected as number[])
                    .map(
                      val =>
                        divisionOptions.find(opt => opt.value === val)?.label ??
                        '',
                    )
                    .filter(label => label !== '')
                    .join(', ')
                }
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 300,
                      width: 'auto',
                    },
                  },
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                  },
                  transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                  },
                }}>
                {divisionOptions.map(option => (
                  <MenuItem key={option.value} value={option.value}>
                    <Checkbox checked={tempSelection.includes(option.value)} />
                    <ListItemText primary={option.label} />
                  </MenuItem>
                ))}

                <Box
                  sx={{
                    position: 'sticky',
                    bottom: 0,
                    background: '#fff',
                    borderTop: '1px solid #ddd',
                    p: 1,
                    display: 'flex',
                    justifyContent: 'space-between',
                    gap: 1,
                  }}>
                  <MenuItem
                    onClick={
                      tempSelection.length === divisionOptions.length
                        ? handleDeselectAll
                        : handleSelectAll
                    }>
                    <ListItemText
                      primary={
                        tempSelection.length === divisionOptions.length
                          ? 'Deselect All'
                          : 'Select All'
                      }
                      primaryTypographyProps={{style: {fontWeight: 600}}}
                    />
                  </MenuItem>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'flex-end', // push buttons to right
                      gap: 1,
                      p: 1,
                      position: 'sticky',
                      bottom: 0,
                      background: '#fff',
                      zIndex: 10,
                    }}>
                    <Button color="error" onClick={handleCancel}>
                      {strings.ModuleSpecificUtilitie.reports.Cancel}
                    </Button>
                    <Button variant="contained" onClick={handleDone}>
                      {strings.ModuleSpecificUtilitie.reports.Done}
                    </Button>
                  </Box>
                </Box>
              </Select>
            </FormControl>
          </Box>

          {selectedReportType === 5 && (
            <FormControl fullWidth margin="normal">
              <Autocomplete
                options={employeeOptions || []}
                getOptionLabel={(option: any) =>
                  `${option.fullName} - ${option.employeeCode}`
                }
                onInputChange={(_, value) => setEmployeeSearch(value)}
                onChange={(_, value) =>
                  setSelectedEmployee(value?.userId || null)
                }
                renderInput={params => (
                  <TextField
                    {...params}
                    label="Employee Name/ID"
                    variant="outlined"
                  />
                )}
              />
            </FormControl>
          )}
{(selectedReportType === 9 || selectedReportType === 10) && (
  <FormControl fullWidth margin="normal">
    <InputLabel id="hq-label">HeadQuarter</InputLabel>
    <Select<string[]>
      labelId="hq-label"
      multiple
      open={openHQ}
      onOpen={() => {
        setTempHQ(selectedHQ);
        setOpenHQ(true);
      }}
      onClose={() => setOpenHQ(false)}
      value={selectedHQ}
      renderValue={(selected: string[]) => selected.join(', ')}
      input={<OutlinedInput label="HeadQuarter" />}
      MenuProps={{
        PaperProps: {
          style: {
            maxHeight: 400,
            width: 280,
            display: 'flex',
            flexDirection: 'column',
          },
        },
      }}
    >
      {/* 🔍 Search Box (sticky) */}
      <Box
        sx={{
          position: 'sticky',
          top: 0,
          zIndex: 1,
          backgroundColor: '#fff',
          p: 1,
          borderBottom: '1px solid #ddd',
        }}
      >
        <TextField
          placeholder="Search HeadQuarter"
          size="small"
          fullWidth
          value={searchHQ}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setSearchHQ(e.target.value)
          }
        />
      </Box>

      {/* ✅ Select / Deselect All */}
      <MenuItem
        onClick={() =>
          setTempHQ(
            tempHQ.length === hqDropDown.length ? [] : [...hqDropDown]
          )
        }
      >
        <Checkbox
          checked={tempHQ.length === hqDropDown.length}
          indeterminate={
            tempHQ.length > 0 && tempHQ.length < hqDropDown.length
          }
        />
        <ListItemText
          primary={
            tempHQ.length === hqDropDown.length
              ? 'Deselect All'
              : 'Select All'
          }
        />
      </MenuItem>

      {/* 📋 HQ List (scrollable) */}
      <Box sx={{ flex: 1, overflowY: 'auto' }}>
        {hqDropDown
          .filter((hq) =>
            hq?.toLowerCase().includes(searchHQ.toLowerCase())
          )
          .map((hq) => (
            <MenuItem
              key={hq}
              value={hq}
              onClick={() =>
                setTempHQ((prev) =>
                  prev.includes(hq)
                    ? prev.filter((name) => name !== hq)
                    : [...prev, hq]
                )
              }
            >
              <Checkbox checked={tempHQ.includes(hq)} />
              <ListItemText primary={hq} />
            </MenuItem>
          ))}
      </Box>

      {/* 🚪 Footer (sticky bottom) */}
      <Box
        sx={{
          borderTop: '1px solid #ddd',
          p: 1,
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 1,
          backgroundColor: '#fff',
          position: 'sticky',
          bottom: 0,
          zIndex: 1,
          boxShadow: '0 -2px 4px rgba(0,0,0,0.1)',
        }}
      >
        <Button
          size="small"
          onClick={() => {
            setOpenHQ(false);
            setTempHQ(selectedHQ);
            setSearchHQ('');
          }}
        >
          {strings.ModuleSpecificUtilitie.reports.Cancel}
        </Button>
        <Button
          size="small"
          variant="contained"
          onClick={() => {
            setSelectedHQ(tempHQ);
            setOpenHQ(false);
            setSearchHQ('');
          }}
        >
          {strings.ModuleSpecificUtilitie.reports.Done}
        </Button>
      </Box>
    </Select>
  </FormControl>
)}



          {selectedReportType === 3 && (
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Box mt={3} display="flex" gap={3}>
                <FormControl fullWidth>
                  <DatePicker
                    label="Start Date"
                    value={startDate}
                    onChange={newValue => {
                      setStartDate(newValue);
                      setStartDateError(validateDate(newValue, 'start'));
                    }}
                    renderInput={params => <TextField {...params} />}
                  />
                  {startDateError && (
                    <FormHelperText error>{startDateError}</FormHelperText>
                  )}
                </FormControl>

                <FormControl fullWidth>
                  <DatePicker
                    label="End Date"
                    value={endDate}
                    onChange={newValue => {
                      setEndDate(newValue);
                      setEndDateError(validateDate(newValue, 'end'));
                    }}
                    renderInput={params => <TextField {...params} />}
                  />
                  {endDateError && (
                    <FormHelperText error>{endDateError}</FormHelperText>
                  )}
                </FormControl>
              </Box>
            </LocalizationProvider>
          )}

          {(selectedReportType === 5 ||
            selectedReportType === 6 ||
            selectedReportType === 7 ||
            selectedReportType === 10) && (
            <Box mt={3} display="flex" gap={3}>
              {/* Months Multi-select */}
              <FormControl fullWidth>
                <InputLabel>
                  {' '}
                  {strings.ModuleSpecificUtilitie.reports.Months}
                </InputLabel>
                <Select
                  multiple
                  open={monthMenuOpen}
                  onOpen={handleMonthOpen}
                  onClose={handleMonthCancel}
                  value={tempMonths} // Use tempMonths for the current selection
                  onChange={e => setTempMonths(e.target.value as number[])}
                  input={<OutlinedInput label="Months" />}
                  renderValue={
                    selected =>
                      (selected as number[])
                        .map(
                          val => MONTHS.find(m => m.value === val)?.label ?? '',
                        ) // Map to month labels
                        .join(', ') // Join with commas
                  }
                  MenuProps={{
                    PaperProps: {style: {maxHeight: 300, width: 'auto'}},
                    anchorOrigin: {vertical: 'bottom', horizontal: 'left'},
                    transformOrigin: {vertical: 'top', horizontal: 'left'},
                  }}>
                  {MONTHS.map(month => (
                    <MenuItem key={month.value} value={month.value}>
                      <Checkbox checked={tempMonths.includes(month.value)} />
                      <ListItemText primary={month.label} />
                    </MenuItem>
                  ))}
                  <Box
                    sx={{
                      position: 'sticky',
                      bottom: 0,
                      background: '#fff',
                      borderTop: '1px solid #ddd',
                      p: 1,
                      display: 'flex',
                      justifyContent: 'space-between',
                      gap: 1,
                    }}>
                    <MenuItem
                      onClick={
                        tempMonths.length === MONTHS.length
                          ? handleMonthDeselectAll
                          : handleMonthSelectAll
                      }>
                      <ListItemText
                        primary={
                          tempMonths.length === MONTHS.length
                            ? 'Deselect All'
                            : 'Select All'
                        }
                        primaryTypographyProps={{style: {fontWeight: 600}}}
                      />
                    </MenuItem>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: 1,
                        p: 1,
                        position: 'sticky',
                        bottom: 0,
                        background: '#fff',
                        zIndex: 10,
                      }}>
                      <Button color="error" onClick={handleMonthCancel}>
                        {strings.ModuleSpecificUtilitie.reports.Cancel}
                      </Button>
                      <Button variant="contained" onClick={handleMonthDone}>
                        {strings.ModuleSpecificUtilitie.reports.Done}
                      </Button>
                    </Box>
                  </Box>
                </Select>
              </FormControl>

              <FormControl fullWidth>
                <InputLabel>
                  {' '}
                  {strings.ModuleSpecificUtilitie.reports.Years}
                </InputLabel>
                <Select
                  multiple
                  open={yearMenuOpen}
                  onOpen={handleYearOpen}
                  onClose={handleYearCancel}
                  value={tempYears} // Use tempYears for the current selection
                  onChange={e => setTempYears(e.target.value as number[])}
                  input={<OutlinedInput label="Years" />}
                  renderValue={selected => (selected as number[]).join(', ')} // Display years as comma-separated
                  MenuProps={{
                    PaperProps: {style: {maxHeight: 300, width: 'auto'}},
                    anchorOrigin: {vertical: 'bottom', horizontal: 'left'},
                    transformOrigin: {vertical: 'top', horizontal: 'left'},
                  }}>
                  {YEARS.filter(year => year >= BSVstartYear).map(year => (
                    <MenuItem key={year} value={year}>
                      <Checkbox checked={tempYears.includes(year)} />
                      <ListItemText primary={year} />
                    </MenuItem>
                  ))} 
                  <Box
                    sx={{
                      position: 'sticky',
                      bottom: 0,
                      background: '#fff',
                      borderTop: '1px solid #ddd',
                      p: 1,
                      display: 'flex',
                      justifyContent: 'space-between',
                      gap: 1,
                    }}>
                    <MenuItem
                      onClick={
                        tempYears.length === YEARS.length
                          ? handleYearDeselectAll
                          : handleYearSelectAll
                      }>
                      <ListItemText
                        primary={
                          tempYears.length === YEARS.length
                            ? 'Deselect All'
                            : 'Select All'
                        }
                        primaryTypographyProps={{style: {fontWeight: 600}}}
                      />
                    </MenuItem>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: 1,
                        p: 1,
                        position: 'sticky',
                        bottom: 0,
                        background: '#fff',
                        zIndex: 10,
                      }}>
                      <Button color="error" onClick={handleYearCancel}>
                        {strings.ModuleSpecificUtilitie.reports.Cancel}
                      </Button>
                      <Button variant="contained" onClick={handleYearDone}>
                        {strings.ModuleSpecificUtilitie.reports.Done}
                      </Button>
                    </Box>
                  </Box>
                </Select>
              </FormControl>
            </Box>
          )}
        </>
      )}
      {selectedReportType && (
        <Box mt={4} textAlign="center">
          <Button
            variant="contained"
            color="primary"
            disabled={
              // Division check only when not SFC
              (selectedReportType !== 8 && selectedDivisions.length === 0) ||
              (selectedReportType === 3 && (!startDate || !endDate)) ||
              (selectedReportType === 5) && !selectedEmployee ||
              ([5, 6, 7, 10].includes(selectedReportType) &&
                (selectedMonths.length === 0 || selectedYears.length === 0))
            }
            onClick={handleDownload}>
            {strings.ModuleSpecificUtilitie.reports.Download}
          </Button>
        </Box>
      )}
      <DownloadProgressDialog open={isLoading} />
    </Box>
  );
};
